import { render, staticRenderFns } from "./ManageProducts.vue?vue&type=template&id=ed058a9c&scoped=true"
import script from "./ManageProducts.vue?vue&type=script&lang=js"
export * from "./ManageProducts.vue?vue&type=script&lang=js"
import style0 from "./ManageProducts.vue?vue&type=style&index=0&id=ed058a9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed058a9c",
  null
  
)

export default component.exports